import type { CreateSchemaKind } from '@cli-types/core-engine/commands.js'
import { fail } from '../schema-prompts/fail.js'

export function normalizeKind(kind: string): CreateSchemaKind {
  if (kind === 'entity' || kind === 'single' || kind === 'form') {
    return kind
  }

  fail(`Unsupported schema kind "${kind}". Use "entity", "single", or "form".`)
}
